module.exports = __webpack_public_path__ + "static/media/map-outline-01.98054196.svg";